import { leadingZeros } from "./numbers"

const months = [
    { id: 1, name: 'Gennaio' },
    { id: 2, name: 'Febbraio' },
    { id: 3, name: 'Marzo' },
    { id: 4, name: 'Aprile' },
    { id: 5, name: 'Maggio' },
    { id: 6, name: 'Giugno' },
    { id: 7, name: 'Luglio' },
    { id: 8, name: 'Agosto' },
    { id: 9, name: 'Settembre' },
    { id: 10, name: 'Ottobre' },
    { id: 11, name: 'Novembre' },
    { id: 12, name: 'Dicembre' },
]

const addDays = (days, date) => {
    const copy = new Date(date)
    const newDate = copy.setDate(copy.getDate() + days)

    return new Date(newDate)
}

const subDays = (days, date) => {
    const copy = new Date(date)
    const newDate = copy.setDate(copy.getDate() - days)

    return new Date(newDate)
}

const restoreDate = date => {
    if(typeof date === 'string' && date.includes('/')) {
        const datetime = date.split(' ')
        const date_only = datetime[0]
        const parts = date_only.split('/')

        return parts[2] + '-' + parts[1] + '-' + parts[0]
    }

    return date
}

const dateFormat = (date, format = 'd/m/Y') => {
    if(! date) {
        return ''
    }

    if(typeof date === 'string' && date.includes('/')) {
        date = restoreDate(date)
    }

    if(typeof date === 'string' && date.includes('-')) {
        date = new Date(date)
    }

    if(format === 'd/m/Y') {
        return leadingZeros(date.getDate(), 2) + '/' + (leadingZeros(date.getMonth() + 1, 2)) + '/' + date.getFullYear()
    }

    if(format === 'Y-m-d') {
        return date.getFullYear() + '-' + (leadingZeros(date.getMonth() + 1, 2)) + '-' + leadingZeros(date.getDate(), 2)
    }

    if(format === 'Y-m-d H:I:S') {
        return date.getFullYear() + '-' + (leadingZeros(date.getMonth() + 1, 2)) + '-' + leadingZeros(date.getDate(), 2) + ' ' + date.getHours() + ':' + date.getMinutes() + ':' + date.getSeconds()
    }

    let options = {}

    if(format.includes('w')) {
        options.weekday = 'short'
    }
    if(format.includes('W')) {
        options.weekday = 'long'
    }
    if(format.includes('wn')) {
        options.weekday = 'narrow'
    }

    if(format.includes('d')) {
        options.day = 'numeric'
    }
    if(format.includes('D')) {
        options.day = '2-digit'
    }

    if(format.includes('m')) {
        options.month = 'numeric'
    }
    if(format.includes('M')) {
        options.month = '2-digit'
    }
    if(format.includes('MM')) {
        options.month = 'long'
    }

    if(format.includes('y')) {
        options.year = '2-digit'
    }
    if(format.includes('Y')) {
        options.year = 'numeric'
    }

    if(format.includes('h')) {
        options.hour = 'numeric'
    }
    if(format.includes('H')) {
        options.hour = '2-digit'
    }

    if(format.includes('i')) {
        options.minute = 'numeric'
    }
    if(format.includes('I')) {
        options.minute = '2-digit'
    }

    if(format.includes('s')) {
        options.second = 'numeric'
    }
    if(format.includes('S')) {
        options.second = '2-digit'
    }

    // console.log(date, new Date(date), options);

    return useLocaleDate(new Date(date), options).value
}

const startOfWeek = (date, firstDayOfWeek = 1) => {
    const d = date ? new Date(date) : new Date()
    let weekDay = d.getDay()

    if(weekDay === firstDayOfWeek) {
        return d
    }

    if(weekDay < firstDayOfWeek) {
        weekDay = 7
    }

    if(weekDay > firstDayOfWeek) {
        const diff = weekDay - firstDayOfWeek

        const firstDay = d.setDate(d.getDate() - diff)

        return new Date(firstDay)
    }
}

const endOfWeek = (date, lastDayOfWeek = 0) => {
    const d = date ? new Date(date) : new Date()
    let weekDay = d.getDay()

    if(weekDay === lastDayOfWeek) {
        return d
    }

    if(weekDay > lastDayOfWeek && lastDayOfWeek === 0) {
        lastDayOfWeek = 7
    }

    if(weekDay < lastDayOfWeek) {
        const diff = lastDayOfWeek - weekDay

        const lastDay = d.setDate(d.getDate() + diff)

        return new Date(lastDay)
    }

    return new Date()
}

const startOfMonth = date => {
    date = date ? new Date(date) : new Date()

    const year = date.getFullYear()
    const month = date.getMonth()

    return new Date(year, month, 1)
}

const endOfMonth = date => {
    date = date ? new Date(date) : new Date()

    const year = date.getFullYear()
    const month = date.getMonth()

    // Day 0 of the next month = last day of the current month (handles leap years)
    return new Date(year, month + 1, 0)
}

const weekDay = (date) => {
    return dateFormat(date, 'W')
}

const isAfter = (first_date, second_date) => {
    return new Date(restoreDate(first_date)) > new Date(restoreDate(second_date))
}

const isBefore = (first_date, second_date) => {
    return new Date(restoreDate(first_date)) < new Date(restoreDate(second_date))
}

const isFuture = (date) => {
    return new Date(restoreDate(date)) > new Date()
}

export {
    months,
    addDays,
    subDays,
    dateFormat,
    startOfWeek,
    endOfWeek,
    startOfMonth,
    endOfMonth,
    weekDay,
    restoreDate,
    isAfter,
    isBefore,
    isFuture,
}
